import { render, staticRenderFns } from "./superuser-cart-product-item.vue?vue&type=template&id=4b3dc736&"
import script from "./superuser-cart-product-item.vue?vue&type=script&lang=js&"
export * from "./superuser-cart-product-item.vue?vue&type=script&lang=js&"
import style0 from "./superuser-cart-product-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports